import { AssetType } from '@ve-pro/enums/asset'
import { SegmentType } from '@ve-pro/enums/segment'

export const SegmentAssetMap: Record<AssetType, SegmentType> = {
  [AssetType.Audio]: SegmentType.Audio,
  [AssetType.Filter]: SegmentType.Filter,
  [AssetType.Animation]: SegmentType.Sticker,
  [AssetType.Text]: SegmentType.Text,
  [AssetType.Video]: SegmentType.Video,
  [AssetType.Image]: SegmentType.Video,
  [AssetType.Transition]: SegmentType.Transition,
}
